import { Formik, Form, Field, ErrorMessage } from 'formik'
import { serviceProviderSchema } from '../../validation/serviceProvider.schema'
import { getUniqueCountryCodes } from '../../utils/countryCodes'
import { useRef, useState } from "react";
import { toast } from 'react-toastify';
import { Grid, FormHelperText } from '@mui/material';

function ServiceProviderForm({ initialValues, onSubmit, submitLabel, logo }) {
   const [selectedFile, setSelectedFile] = useState(null);
   console.log(selectedFile, "setFieldValue");
   const [fileError, setFileError] = useState(null);
   const fileRef = useRef();
   const countryCodes = getUniqueCountryCodes();

   const handleFileChange = (e, setFieldValue) => {
      const file = e.target.files[0];
      if (!file) return;

      const allowedTypes = [
         'image/jpeg',
         'image/jpg',
         'image/png'
      ];

      if (!allowedTypes.includes(file.type)) {
         toast.error('Only JPG, PNG files are allowed');
         setFileError('Invalid file type. Only JPG, PNG files are allowed');
         setSelectedFile(null);
         setFieldValue('logo', null);
         e.target.value = '';
         return;
      }

      setFileError(null);
   }
   const removeLogo = (setFieldValue) => {
      logo = '';
      fileRef.current.value = null;
      setFieldValue('logo', null);
      setSelectedFile(null);
   }

   return (
      <Formik
         initialValues={initialValues}
         validationSchema={serviceProviderSchema}
         onSubmit={onSubmit}
         enableReinitialize
         validateOnMount
      >
         {({
            setFieldValue,
            isSubmitting,
            values,
            dirty,
            isValid,
            errors,
            touched,
         }) => (
            <Form noValidate>

               {/* Name */}
               <div className="form-group">
                  <label htmlFor="name">Name <span className="text-danger">*</span></label>
                  <Field
                     id="name"
                     name="name"
                     className="form-control"
                     placeholder="Enter provider name"
                     disabled={isSubmitting}
                     onError={touched.name && errors.name}
                  />
                  {/* <ErrorMessage name="name" component="div" className="text-danger" /> */}
                  {touched.name && (<FormHelperText sx={{ color: '#d32f2f', margin: '3px 14px' }}>
                     {touched.name && errors.name} </FormHelperText>)}
               </div>

               {/* Email */}
               <div className="form-group">
                  <label htmlFor="email">Email Address <span className="text-danger">*</span></label>
                  <Field
                     id="email"
                     name="email"
                     type="email"
                     className="form-control"
                     placeholder="Enter email address"
                     disabled={isSubmitting}
                     onError={touched.email && errors.email}
                  />
                  {/* <ErrorMessage name="email" component="div" className="text-danger" /> */}
                  {touched.email && (<FormHelperText sx={{ color: '#d32f2f', margin: '3px 14px' }}>
                     {touched.email && errors.email} </FormHelperText>)}
               </div>

               {/* Phone Number */}
               <div className="form-group">
                  <label htmlFor="phoneNumber">Phone Number <span className="text-danger">*</span></label>
                  <div className="input-group">
                     <select
                        name="countryCode"
                        className="form-control"
                        style={{ minWidth: '200px', maxWidth: '200px' }}
                        value={values.countryCode}
                        onChange={(e) => setFieldValue('countryCode', e.target.value)}
                        disabled={isSubmitting}
                        onError={touched.countryCode && errors.countryCode}
                     >
                        <option value="">Select Code</option>
                        {countryCodes.map((item) => (
                           <option key={item.code} value={item.code}>
                              {item.country} ({item.code})
                           </option>
                        ))}
                     </select>
                     <Field
                        id="phoneNumber"
                        name="phoneNumber"
                        type="tel"
                        className="form-control"
                        placeholder="Enter phone number"
                        disabled={isSubmitting}
                        onError={touched.phoneNumber && errors.phoneNumber}
                     />
                  </div>
                  {/* {errors.countryCode && touched.countryCode && (
                     <div className="text-danger">{errors.countryCode}</div>
                  )}
                  {errors.phoneNumber && touched.phoneNumber && (
                     <div className="text-danger">{errors.phoneNumber}</div>
                  )}
                  <small className="form-text text-muted">Select your country code and enter your phone number.</small> */}
                  {touched.phoneNumber && (<FormHelperText sx={{ color: '#d32f2f', margin: '3px 14px' }}>
                     {touched.phoneNumber && errors.phoneNumber} </FormHelperText>)}
               </div>

               <Grid container spacing={3}>
                  {/* Address */}
                  <Grid item md={8} xs={12}>
                     <div className="form-group">
                        <label htmlFor="address">Address <span className="text-danger">*</span></label>
                        <Field
                           id="address"
                           name="address"
                           className="form-control"
                           placeholder="Enter full address"
                           disabled={isSubmitting}
                           onError={touched.address && errors.address}
                        />
                        {/* <ErrorMessage name="address" component="div" className="text-danger" /> */}
                        {touched.address && (<FormHelperText sx={{ color: '#d32f2f', margin: '3px 14px' }}>
                           {touched.address && errors.address} </FormHelperText>)}
                     </div>
                  </Grid>

                  {/* Status */}
                  <Grid item md={4} xs={12}>
                     <div className="form-group">
                        <label htmlFor="status">Status</label>
                        <select
                           id="status"
                           className="form-control"
                           value={String(values.status)}
                           onChange={(e) => setFieldValue('status', e.target.value === 'true')}
                           disabled={isSubmitting}
                        >
                           <option value="true">Active</option>
                           <option value="false">Inactive</option>
                        </select>
                        <ErrorMessage name="status" component="div" className="text-danger" />
                     </div>
                  </Grid>
               </Grid>

               {/* Logo Upload */}
               <div className="form-group">
                  <label htmlFor="logo">Logo</label>

                  {/* Preview */}
                  {(selectedFile || logo) && (
                     <div className="mb-2">
                        <img
                           src={
                              selectedFile
                                 ? URL.createObjectURL(selectedFile)
                                 : process.env.REACT_APP_API_URL + logo.split('/').slice(3).join('/') ?? ''
                           }
                           alt="Logo Preview"
                           style={{
                              maxWidth: '200px',
                              maxHeight: '120px',
                              width: '100%',
                              height: 'auto',
                              objectFit: 'contain',
                              borderRadius: '8px',
                              border: '1px solid #ddd',
                              padding: '4px',
                              backgroundColor: '#fff',
                              display: 'block',
                           }}
                        />
                     </div>
                  )}
                  {(values.logo || logo) && <button
                     type="button"
                     onClick={() => removeLogo(setFieldValue)}
                     style={{ 
                        padding: '5px 10px',
                        border: 'none',
                        fontSize: '14px',
                        backgroundColor: 'red',
                        color: '#fff',
                        borderRadius: '7px',
                        marginBottom: '20px',
                     }}
                  >Remove Logo
                  </button>}

                  <input
                     ref={fileRef}
                     id="logo"
                     type="file"
                     className="form-control"
                     disabled={isSubmitting}
                     onChange={(e) => {
                        setSelectedFile(e.currentTarget.files[0]);
                        setFieldValue('logo', e.currentTarget.files[0]);
                        handleFileChange(e, setFieldValue);
                     }}
                  />
                  <small className="form-text text-muted">Only .jpg, .png, .jpeg are allowed.</small>
                  {fileError && <small className="form-text text-danger">{fileError}</small>}
               </div>

               {/* Submit */}
               <div className="mt-3">
                  <button
                     type={'submit'}
                     className="btn commonBtn"
                     disabled={isSubmitting}
                  // onClick={
                  //    !dirty
                  //       ? () =>
                  //          submitLabel !== 'Create'
                  //             ? toast.error('Make a change to update')
                  //             : toast.error('Please enter values for required fields')
                  //       : null
                  // }
                  >
                     {isSubmitting ? (
                        <>
                           <span
                              className="spinner-border spinner-border-sm mr-2"
                              role="status"
                              aria-hidden="true"
                           />
                           Submitting...
                        </>
                     ) : (
                        submitLabel
                     )}
                  </button>
               </div>

            </Form>
         )}
      </Formik>
   )
}

export default ServiceProviderForm